import parseLinkHeader from 'parse-link-header';

const LINK_HEADER_REL = 'rel="auth"';

export const ASSERT_OK = 'ASSERT_OK';
export const ASSERT_STATUS_CODE = 'ASSERT_STATUS_CODE';

export const AUTHENTICATION_ERROR = 'AUTHENTICATION_ERROR';

export class BaseError extends Error {
    code: string;

    constructor(...params: any[]) {
        super(...params);

        // required to keep prototype chain when targeting ES5 see
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class AuthenticationError extends BaseError {
    code = AUTHENTICATION_ERROR;
    statusCode: number;
    redirectTarget?: string;

    constructor(statusCode: number, linkHeader: string | null, ...rest: any[]) {
        super(...rest);

        this.statusCode = statusCode;

        if (!linkHeader) {
            return;
        }

        const links = parseLinkHeader(
            linkHeader.indexOf(LINK_HEADER_REL) === -1
                ? `${linkHeader};${LINK_HEADER_REL}`
                : linkHeader,
        );

        if (!links) {
            return;
        }

        this.redirectTarget = links.auth.url;
    }
}

export class AssertOkError extends BaseError {
    code = ASSERT_OK;
}

export class AssertStatusCode extends BaseError {
    code = ASSERT_STATUS_CODE;
    statusCode: number;

    constructor(statusCode: number, ...rest: any[]) {
        super(...rest);
        this.statusCode = statusCode;
    }
}
